<!-- <app-common-page-breadcrumbs [pageTitle]="title" [navigationData]="navigationData"></app-common-page-breadcrumbs> -->
<div class=" container mw-100 group-company-div visible-xs ">
    <nav class="navbar navbar-expand-lg navtext visible-flex-xs transparent p-0">
    <a class="navbar-brand" [routerLink]="'/inventory/inventorymanagement' | cxUrl"><img src="/images/BHP_white.svg" alt="customlogo" width="50.65px" height="22px"></a>
    <a class="navbar-brand"><img src="/images/right_arrow.svg" alt="customlogo" width="24px" height="24px"></a>
  <span class="position-absolute group-company-dropdown text-white "><b>Inventory Management</b></span>
  <div class="collapse navbar-collapse" id="navbarSupportedContent">
    <div class="nav-item dropdown position-absolute d-flex align-items-center" style="right:0">
      <span class="text-white bold">{{loginData.userId}}</span>
      <span name='account' class=" nav-link nav-border rounded-0 dropbtn" role="button" id="navbarDropdown3" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"> <i class="fas fa-user-circle icon-style ipad-orientation fa-2x"></i></span>
      <div class="dropdown-menu account-dropdown mobdrop dropdown-content" aria-labelledby="navbarDropdown" >
       <!-- <h5 (click)="goToUpdatePersonalDetails()" [routerLink]="['profile/my-account/update-personal-details']"><a class="anchor-tag strong">Update Personal details</a></h5>
       <hr>
       <h5 (click)="goToResetPassword()" [routerLink]="['profile/my-account/change-password']" ><a class="anchor-tag strong">Reset Password</a></h5>
       <hr> -->
       <h5 (click)="inventorylogout()"><a class="anchor-tag strong">Logout</a></h5>
      </div>
</div>
    </div>
</nav>
</div>
<!--mobile header-->
<div class='hidden-xs container mobile-inv'>
	<div class="hidden-xs-inv   navtext mobile-view-div d-flex justify-content-between">
		<div class="bhp-mobile"> 
      <a class="navbar-brand" [routerLink]="'/inventory/inventorymanagement' | cxUrl"><img src="/images/BHP_white.svg" alt="customlogo"><img src="/images/right_arrow.svg" alt="customlogo" ><span class=" group-company-dropdown mobile-management text-white "><b>Inventory Management</b>
      </span></a>
</div>
<div class="nav-item dropdown inline-flex nav-icon-mobile-view">
    <span name='ipadaccount' class=" user-account-icon-btn " id="navbarDropdown5" role="button" aria-haspopup="true" aria-expanded="false" (click)="showUserProfile=!showUserProfile">
      <i class="fas fa-user-circle icon-style-mobile ipad-orientation fa-2x fa-mobile-icon"></i>
                </span>
              </div>
	</div>
</div>
<!-- profile div mobile -->
<div *ngIf="showUserProfile" class="hidden-xs  navbar-dark bg-dark navtext user-Profile border-dark">
  <!-- <h5 (click)="showUserProfile=!showUserProfile" (click)='goToUpdatePersonalDetails()' [routerLink]="['profile/my-account/update-personal-details']">Update personal details</h5>
  <hr>
  <h5 (click)="showUserProfile=!showUserProfile" (click)='goToResetPassword()' [routerLink]="['profile/my-account/change-password']">Reset password
  </h5>
  <hr> -->
<h5 (click)="inventorylogout()" (click)="showUserProfile=!showUserProfile"  >Logout</h5>
</div>
<!--filter functionality-->
<div class="filter-nav  overflow-visible " >
    <div class="container visible-xs-filter-bar">
      <div class="d-flex justify-content-between">
        <div class="d-flex">
          <!-- <div class="strong text-black  p-2 text-nowrap">{{ 'home.productHeader.Filter' | cxTranslate }}</div> -->
          <div class="strong text-black  p-2 text-nowrap">Filter by:</div>
          <div class="mr-2">
           <ng-select [items]="ports" [multiple]="true" [clearable]="false" bindLabel="name" dropdownPosition="bottom" groupBy="ports"
               [selectableGroup]="false" 
              [closeOnSelect]="true" placeholder="{{'shipment.SelectPorts' | cxTranslate}}" bindValue="id"
              [(ngModel)]="selectedPort" notFoundText="No Items Found">
              <ng-template ng-multi-label-tmp>
                <span class="filter-count pl-2 text-black">{{selectedPort?.length}}x Ports Selected</span>
              </ng-template>
              <ng-template ng-optgroup-tmp let-item="item" let-item$="item$" let-index="index">
                <input type="checkbox" /><span class="ff-semibold "> Ports</span>
              </ng-template>
              <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
              <div (pointerdown)="getPortFacets(item)">
                <input   *ngIf="item.name!==undefined && item.name!==''" id="{{item.id}}" type="checkbox"
                [ngModel]="item$.selected" [checked]="item.selected" /> <span >{{item.name}}</span>
              </div>  
              </ng-template>
            </ng-select>  
  
          </div>
          <div class="mr-2">
            <ng-select [items]="productTypes" [multiple]="true" [clearable]="false" bindLabel="name" dropdownPosition="bottom"
               groupBy="productType"
              placeholder="Select product types" [selectableGroup]="false"
              [closeOnSelect]="true" bindValue="id" [(ngModel)]="selectedProductType"
              notFoundText="No Items Found">
              <!-- <ng-template ng-multi-label-tmp>
                <span class="ng-placeholder">{{selectedProductType.length}}x {{ 'home.productHeader.SelectedTypes' |
                  cxTranslate }}</span>
              </ng-template> -->
              <ng-template ng-multi-label-tmp>
                <span class="filter-count pl-2 text-black">{{selectedProductType?.length}}x Types Selected</span>
              </ng-template>
              <ng-template ng-optgroup-tmp let-item="item" let-item$="item$" let-index="index"
                class="dropdown-ng-template">
                <input type="checkbox" /> <span class="ff-semibold">Product Types</span>
              </ng-template>
              <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
               <div (pointerdown)="getTypeFacets(item)">
                <input  *ngIf="item.name!==undefined && item.name!==''" id="{{item.id}}" [ngModel]="item$.selected" [checked]="item.selected"  type="checkbox"
                   /> <span >{{item.name}}</span>
                </div> 
              </ng-template>
            </ng-select>
          </div>
          <div class="mr-2">
            <ng-select #testselect [items]="productsList" [multiple]="true" [clearable]="false" bindLabel="name" dropdownPosition="bottom"
              groupBy="product"
              placeholder="Select products" [selectableGroup]="false"
              [closeOnSelect]="true" bindValue="id" [(ngModel)]="selectedProduct"
              notFoundText="No Items Found">
              <!-- <ng-template ng-multi-label-tmp>
                <span class="ng-placeholder text-black">{{selectedProduct.length}}x {{
                  'home.productHeader.SelectedProducts' | cxTranslate }}</span>
              </ng-template> -->
              <ng-template ng-multi-label-tmp>
                <span class="filter-count pl-2 text-black">{{selectedProduct?.length}}x Products Selected</span>
              </ng-template>
  
              <ng-template ng-optgroup-tmp let-item="item" let-item$="item$" let-index="index"
                class="dropdown-ng-template">
                <input type="checkbox" /><span class="ff-semibold"> Products</span>
              </ng-template>
              <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                <div (pointerdown)="getProductsFacet(item)">
                 <input  *ngIf="item.name!==undefined && item.name!==''" id="{{item.id}}" [ngModel]="item$.selected" [checked]="item.selected"  type="checkbox"
                    /> <span >{{item.name}}</span>
                 </div> 
               </ng-template>
              <!-- <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                <input *ngIf="item.name!==undefined && item.name!==''" id="{{item.id}}" type="checkbox"
                [ngModel]="item$.selected" [checked]="item.selected"/> {{item.name}}
              </ng-template> -->
            </ng-select>
          </div>
          
            <div *ngIf="showClear">
              <button type="button" class="btn btn-warning clear-text " (click)="clearAllFilter()">Clear filter</button>
            </div>
  
          
        </div>
        <!--search function desktop-->
        <div class="d-inline-flex contractsearch search-zindex ml-lg-5 my-3 filter-select-div">
          <div class="input-group">
              <input class="form-control form-control-lg border-search " [(ngModel)]="searchValue" type="search" placeholder="Search by Batch ID" id="example-search-input" (keypress)="omitSpecialChar($event)"
              />
              <span class="input-group-append">
<button name='searchbuttonfilternew'
  class="btn rounded-pill border-0 border-start-0 bg-white border-bottom-0 border ms-n5 search-height">
  <i class="fa fa-search pe-none"></i>
</button>
</span>
</div>
</div>
      </div>
    </div>
    <div class="container hidden-xs-filter-bar">
      <div class="row">
        <div class="w-100">
          <div class="filter-select-div-mobile pl-4">
            <div class="input-group">
              <input class="form-control form-control-lg border rounded-pill input-field" type="search"
                (keypress)="omit_special_char($event)" [(ngModel)]="searchValue" placeholder="Search by Batch ID">
              <span class="input-group-append">
                <button name='searchbuttonfilter' class="
                      btn
                      
                      border-0
                      input-field
                      border-start-0 border-bottom-0 border
                      ms-n5
                    " type="button">
                  <i class="fa fa-search mobbar"></i>
                </button>
                <div class='hidden-xs-filter-bar vertical ml-4'></div>
                <div class='hidden-xs-filter-bar pr-2 pl-4' (click)='filtersidebar()'>
                  <img class="ml-1" src="./images/filternew.svg"><sup class="pl-2 pr-2 pt-1 pb-1"
                    *ngIf='length'>{{length}}</sup>
                  <div class="ff-semibold fs-10 d-flex align-items-center text-black Filternew">Filters</div>
                </div>
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="background">
        <div [ngClass]="sidebar ?'hide-mobile-filter-sidebar': 'mobile-filter-sidebar' " class="hidden-xs-filter-bar sidebar">
          <div class='sticky-top  d-flex justify-content-between p-3 border sticky'>
            <div class="fs-24 strong pl-1">Filter by:</div>
            <div (click)="closebar()"><img src="/images/sidebarcross.svg"
                alt=""> </div>
          </div>
          <div>
            <div>
              <div class="d-flex strong  pl-3 pt-3 pb-2">Ports :</div>
              <div *ngFor="let portData of ports; let i=index" class="ml-5  d-flex line-height">
                <label class="ff-normal" *ngIf="portData.name!==undefined && portData.name!==''">
                  <input type="checkbox" [(ngModel)]="portData.selected" [value]="portData.id"
                    [checked]="portData.selected"
                    (change)="getFacetsMobile(portData)" />
                  {{portData.name}}
                </label>
              </div>
            </div>
            <div class="d-flex strong  pl-3 pt-3 pb-2">Product Types :</div>
            <div *ngFor="let productType of productTypes; let i=index" class="ml-5  d-flex line-height">
              <label class="ff-normal" *ngIf="productType.name!==undefined && productType.name!==''">
                <input type="checkbox" [(ngModel)]="productType.selected" [value]="productType.id"
                  [checked]="productType.selected"
                  (change)="getFacetsMobile(productType)" />
                {{productType.name}}
              </label>
            </div>
          </div>
          <div class="d-flex strong  pl-3 pt-3 pb-2">Products:</div>
          <div *ngFor="let productData of productsList; let i=index" class="ml-5  d-flex line-height">
            <label class="ff-normal" *ngIf="productData.name!==undefined && productData.name!==''">
              <input type="checkbox" [(ngModel)]="productData.selected" [value]="productData.id"
                [checked]="productData.selected" (change)="getFacetsMobile(productData)" />
              {{productData.name}}
            </label>
          </div>
  
          <div class="sticky-bottom p-4 border-top">
            <button class="btn btn-block btn-primary w-100" (click)="submitForm()">See results</button>
            <button class='btn btn-block' (click)="clearFilterDataMobile($event);closebar()">Clear Filter</button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!--content-->
  <div class="py-4 container">
    <br>
    <section id="tabs" class="project-tab ipad-pro">
      <div class="container">
        <div class="row pl-3">
          <div class="col-lg-6 tabDiv">
            <nav class="product-tab">
              <div class="nav nav-tabs nav-fill pe-auto" id="nav-tab" role="tablist">
                <div class="nav-item nav-link active tab-bar strong " id="nav-home-tab" data-toggle="tab"
                  href="#nav-by-port" role="tab" aria-controls="nav-home" aria-selected="true"
                  (click)="changeTab('active')">Published Batches
                </div>
                <div class="nav-item nav-link tab-bar strong " id="nav-profile-tab" data-toggle="tab"
                  href="#nav-by-product" role="tab" aria-controls="nav-profile" aria-selected="false"
                  (click)="changeTab('completed')">Unpublished Batches
                </div>
                <div class="nav-item nav-link tab-bar strong " id="nav-contact-tab" data-toggle="tab" href="#nav-all"
                  role="tab" (click)="changeTab('archived')" aria-controls="nav-contact" aria-selected="false">Archived Batches</div>
              </div>
            </nav>
          </div>
          <div class=" mobdisplay gird-div display-top mt-n1 visible-xs-filter-bar ml-auto">
            <span *ngIf="true" class="grid-icon css-sort">
              <span class="mr-2">
                Sort by :
              </span>
              <select class="dropdownClass" (change)="selectChangeHandler($event)">
                <option value="creationTime:desc">Creation Date (Desc)</option>
                <option value="creationTime:asc">Creation Date (Asc)</option>
                <option value="code:desc">Batch ID (Desc)</option>
                <option value="code:asc">Batch ID (Asc)</option>
                <option value="name:desc">Product Name (Desc)</option>
                <option value="name:asc">Product Name (Asc)</option>
              </select>
            </span>
            <span class="grid-icon ml-3">Display as:<img class="list-icon"
                (click)="viewList()" [src]='listSrc'>
              <img class="grid-icon" (click)="viewGrid()" [src]='gridSrc'>
            </span>
          </div>
        </div>
      </div>
      <hr>
      <!-- content area -->
      <div class="tab-content" id="nav-tabContent">
        <!-- <div class="tab-pane fade show active" id="nav-by-active" role="tabpanel" aria-labelledby="nav-active-tab">
                 <app-inventory-unpublished-batch [inventoryTab]="this.inventoryTab"></app-inventory-unpublished-batch>
              </div>
              <div class="tab-pane fade show active" role="tabpanel" id="nav-by-completed" aria-labelledby="nav-accepted-tab">
                  <app-inventory-unpublished-batch [inventoryTab]="this.inventoryTab"></app-inventory-unpublished-batch>
              </div>
              <div class="tab-pane fade show active" role="tabpanel" id="nav-by-archived" aria-labelledby="nav-archived-tab">
                      <app-inventory-unpublished-batch [inventoryTab]="this.inventoryTab"></app-inventory-unpublished-batch>
              </div> -->
        <div class="tab-pane fade show active" role="tabpanel">
          <app-inventory-unpublished-batch [inventoryTab]="inventoryTab" [list]="list" [grid]="grid"
            [sortData]="selectedSort" [searchValue]="searchValue"></app-inventory-unpublished-batch>
        </div>
      </div>
    </section>
  </div>